import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { ContactFooter } from "./components/ContactFooter";
import { ScrollManager } from "./components/ScrollManager";
import { Home } from "./pages/Home";
import { Thoughts } from "./pages/Thoughts";
import { ThoughtPost } from "./pages/ThoughtPost";
import { CaseStudy } from "./pages/CaseStudy";
import { NotFound } from "./pages/NotFound";
import { LogoDownload } from "./pages/LogoDownload";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mnngs5hxqe1t">
      <ScrollManager data-id="element-1" data-mp="2mjzplczyq3q9" />
      <div className="relative w-full bg-espresso" data-id="element-2" data-mp="31b8ka0iq2fa9">
        <a href="#main-content" className="skip-link" data-id="element-3" data-mp="31c1igd3m7wgs">
          Skip to content
        </a>
        <Header data-id="element-4" data-mp="2wip6b2g4hi4x" />
        <Routes data-id="element-5" data-mp="2whxd1y9zzwht">
          <Route path="/" element={<Home data-id="element-7" data-mp="28tmg367fagyt" />} data-id="element-6" data-mp="28ufmg62gz4gf" />
          <Route path="/thoughts" element={<Thoughts data-id="element-9" data-mp="28sbe9bxjfjac" />} data-id="element-8" data-mp="28t4ju9krg2qw" />
          <Route path="/thoughts/:slug" element={<ThoughtPost data-id="element-11" data-mp="23ujlygszdv5m" />} data-id="element-10" data-mp="23vkuadim43jn" />
          <Route path="/work/:id" element={<CaseStudy data-id="element-13" data-mp="3ik7k0rkruvvx" />} data-id="element-12" data-mp="23t8g8bfz6dbv" />
          <Route path="/logo" element={<LogoDownload data-id="element-15" data-mp="3ijpcuzwkmx98" />} data-id="element-14" data-mp="3iiwfuqnezm4a" />
          <Route path="*" element={<NotFound data-id="element-17" data-mp="3mkrdnl64zhdb" />} data-id="element-16" data-mp="3mlj98vzqhf3l" />
        </Routes>
        <ContactFooter data-id="element-18" data-mp="3mjq2zht18ww4" />
      </div>
    </BrowserRouter>;
}